import WindowPanel from "../components/WindowPanel";
import { style } from "../style";


export default function Home()
{

    return (
        <>
            <h1 className={style.h1}>Tekworld Monsters Codex</h1>
            <section className={style.section}>
                <div className={style.prose}>
                    <p className={style.textBig + " " + style.h2 + " !font-light"}>
                        Somewhere in Japan, inside an unreleased prototype game cartridge, inserted into an abandonded game console, somehow still plugged in for decades, exists a world full of monsters.
                    </p>
                </div>
            </section>
            <div className={style.panelGroup}>
                <WindowPanel
                    title="running for three decades"
                    imagePath="/image/home/console.png"
                    addedClassGroup="flex-1"
                />
                <WindowPanel
                    title="average tekbro day"
                    imagePath="/image/home/key_art.png"
                    addedClassGroup="flex-1"
                />
            </div>
        </>
    );

}
